<template>
    <v-container grid-list-md fluid>
        <v-tooltip
            v-if="item.mail ? (item.mail.lastReadDate ? true : false) : false"
            location="bottom"
        >
            <template v-slot:activator="{ props }">
                <v-icon v-bind="props">$fa-envelope-open</v-icon>
            </template>
            <span
                >Contacté le {{ formatDate(item.mail.date) }} et lu le
                {{ formatDate(item.mail.lastReadDate) }}
            </span>
        </v-tooltip>
        <v-tooltip
            v-else-if="item.mail ? (item.mail.date ? true : false) : false"
            location="bottom"
        >
            <template v-slot:activator="{ props }">
                <v-icon v-bind="props">$fa-envelope</v-icon>
            </template>
            <span>Contacté le {{ formatDate(item.mail.date) }}</span>
        </v-tooltip>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class HasMailBeenRead extends Vue {
    @Prop() item: any;

    formatDate(date: Date) {
        if (!date) return "-";
        return moment(date).format("DD/MM/YYYY");
    }
}

export default toNative(HasMailBeenRead);
</script>
